<template>
  <div id="img-content" class="rich_media_wrp">
    <h2 class="zhemo" id="activity-name">
      芒格最新观点 ：价值投资“永不过时”
    </h2>
   

    <div
      id="js_tags"
      class="article-tag__list"
      style="display: none"
      data-len="0"
    >
      <div class="article-tag-card__title">收录于话题</div>
      <div class="article-tags"></div>
    </div>

    <div class="rich_media_content" id="js_content" style="visibility: visible">
      <p
        style="
          
          max-width: 100%;
          box-sizing: border-box;
          overflow-wrap: break-word;
          min-height: 1em;
          letter-spacing: 0.544px;
          white-space: normal;
          font-size: 18px;
          background-color: rgb(255, 255, 255);
          line-height: 1.75em;
          text-indent:2em!important;
          font-family: PingFangSC-Regular, 'PingFang SC', -apple-system,
            BlinkMacSystemFont, 'Open Sans', Arial, 'Hiragino Sans GB',
            'Microsoft YaHei', STHeiti, 'WenQuanYi Micro Hei', SimSun,
            sans-serif;
        "
      >
        <span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            
          "
          >来源：芒格</span
        >
      </p>
      <p
        style="
          margin-top: 20px;
          margin-bottom: 20px;
          max-width: 100%;
          box-sizing: border-box;
          overflow-wrap: break-word;
          min-height: 1em;
          letter-spacing: 0.544px;
          white-space: normal;
          font-size: 18px;
          background-color: rgb(255, 255, 255);
          line-height: 1.75em;
          font-family: PingFangSC-Regular, 'PingFang SC', -apple-system,
            BlinkMacSystemFont, 'Open Sans', Arial, 'Hiragino Sans GB',
            'Microsoft YaHei', STHeiti, 'WenQuanYi Micro Hei', SimSun,
            sans-serif;
        "
      >
        <span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >2月24日，在洛杉矶举行的《每日日报》(Daily Journal
          Corporation)年度股东大会上，</span
        ><ai
          type="7"
          parm="{}"
          style="
            max-width: 100%;
            cursor: pointer;
            display: inline;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            color: inherit !important;
          "
          ><span
            style="
              max-width: 100%;
              font-family: 微软雅黑, 'Microsoft YaHei';
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >伯克希尔哈撒韦公司</span
          ></ai
        ><span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >(Berkshire Hathaway)副董事长、沃伦•</span
        ><ai
          type="15"
          parm="{}"
          style="
            max-width: 100%;
            cursor: pointer;
            display: inline;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            color: inherit !important;
          "
          ><span
            style="
              max-width: 100%;
              font-family: 微软雅黑, 'Microsoft YaHei';
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >巴菲特</span
          ></ai
        ><span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >(Warren Buffett)的长期商业伙伴查理•芒格(Charlie
          Munger)成为焦点人物。</span
        >
      </p>
      <p
        style="
          margin-top: 20px;
          margin-bottom: 20px;
          max-width: 100%;
          box-sizing: border-box;
          overflow-wrap: break-word;
          min-height: 1em;
          letter-spacing: 0.544px;
          white-space: normal;
          font-size: 18px;
          background-color: rgb(255, 255, 255);
          line-height: 1.75em;
          font-family: PingFangSC-Regular, 'PingFang SC', -apple-system,
            BlinkMacSystemFont, 'Open Sans', Arial, 'Hiragino Sans GB',
            'Microsoft YaHei', STHeiti, 'WenQuanYi Micro Hei', SimSun,
            sans-serif;
        "
      >
        <span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >在将近两个小时的时间里，《每日日报》董事会主席芒格和首席执行官杰里·萨尔茨曼(Jerry
          Salzman)回答了股东们提出的各种问题，范围涵盖Gamestop逼空行情、比特币是否有价值、新能源汽车及分散投资策略等领域。</span
        >
      </p>
      
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >先帮没时间细看的读者整理了一个简要版，再附上提问实录。</span
        >
      </section>
      <p><br /></p>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >1，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >出现投机热、出现泡沫，是必然的。我见得太多了，<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >每次我总是告诉自己，要挺过去。我觉得，投资者就该这么做，挺过去。</strong
            ></span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >2，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我相信一个简单的道理：君子求财，取之有道。卖东西赚钱无可厚非，但<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你得卖好东西，对别人好的。</strong
            ></span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >3，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >目前，<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >与持有现金相比，我们更愿意持有股票</strong
            >。我们目前持有这么多有价证券并不是有意为之，可以说是时也、运也。</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >4，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
              
            "
            >在当前利率如此之低的环境下，估计所有人都愿意以高一些的市盈率持有股票。<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >好公司的市盈率比以前高很多，这也没什么不合理的</strong
            >。</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            text-indent: 0;
    display: inline-block;
    margin-left: 21px;
          "
          >我能富有，靠的不是在疯狂的投机热潮中买入高市盈率的股票。我不会改变。只是<strong
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >利率这么低，我更愿意以较高的市盈率持有股票。</strong
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >5，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我很欣赏杰夫·贝索斯，他是最聪明的企业家之一。但是，我不会跟着他。<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我们有自己的一亩三分地</strong
            >。贝索斯做的项目，我搞不太懂，当然</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            text-indent: 0;
    display: inline-block;
    margin-left: 21px;
          "
          >没法跟着投资。</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >6，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我们美国人虽然喜欢自己的国家、自己的制度，但不应该自命不凡地教导中国人，非要让他们像我们一样。要我说，<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我们的制度适合我</strong
            ></span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            text-indent: 0;
    display: inline-block;
    margin-left: 21px;
          "
          >们，中国的制度适合中国。</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >7，</span
              ></strong
            ></span
          ><span style="letter-spacing: 0.544px"
            >我认为，中国政府把经济管理得井井有条，他们管理经济，比我们美国管得好。</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >8，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >贫穷令人们痛苦，<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >贫穷也激发人们摆脱贫穷</strong
            >，促进经济增长。换言之，这是一种自动调节的制度，确实让人感到矛盾。</span
          ></span
        >
      </section>
      
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            text-indent: 0;
    display: inline-block;
    margin-left: 21px;
          "
          >很遗憾，经济学的教科书上都没讲，<strong
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >在一个成长的经济体中，必须要存在贫穷，它才能走出贫穷。人为地、过多地减少贫穷，只能适得其反。我对收入不均的现象不是特别在意。我所观察到的是，很多富裕的家庭很快就失去了权势和财富。一小部分人先富起来不是什么大问题，他们不至于把整个国家搞垮。</strong
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >9，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >别人教给我一个新知识，我知道这是个有用的知识，我会很快把它搞懂弄透，然后自己去用，在生活中学以致用。</span
          ></span
        >
      </section>
      
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            text-indent: 0;
    display: inline-block;
    margin-left: 21px;
          "
          >不会学习方法，你就像个只有一条腿的人和别人比踢屁股，你肯定输。会学习是个了不起的本事。学习能力，这东西是别人很难教给你的，可以说基本就是天生的。</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >10，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >（新科技出现了，却完全不懂，处于劣势怎么办？）</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;text-indent: 0;
    display: inline-block;
    margin-left: 30px;"
          >我的建议是这样的：你有一项劣势，是你能消除的，那就把它消除。消除不了，就学会带着这项劣势生存。不这样，还能怎么办？能补救的，就补救。补救不了的，就接受。</span
        >
      </section>
      
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
     
        <br />

      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >11，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >（当存在两种相互冲突的观点时，我们怎么才能看透？）</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            text-indent: 0;
    display: inline-block;
    margin-left: 30px;
          "
          >在我遇到这种情况的时候，我总是坚持一个标准，这个标准令我受益良多。我的标准是这样的：我有一个观点，别人持有相反的观点，我必须要比别人能更有力地反驳自己的观点，那我对这个问题才真有发言权。
不断练习这种思维方式，你总是在证伪，总是在拷问自己，可以帮助你减少无知。</span
        >
      </section>
      
      
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <br>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >12，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >李光耀有一句口头禅，他经常说：“<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
                text-indent: 0;
    display: inline-block;
    margin-left: 30px;
              "
              >找到正确的方法，按正确的方法做这个道理大家都懂，但没几个人能付诸实践。李光耀能持之以恒地探索，普通人没那个恒心。</strong
            >。”</span
          ></span
        >
      </section>
      <br>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >13，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >旧的护城河不断消失，新的护城河不断形成。如同生物进化，新的物种产生，旧的物种灭亡。这不是以我们的意志为转移的。</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <br>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >14，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >谁让你以为生活是轻松愉快的了？生活本来就很难。</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <br>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >15，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >油气行业未必是好生意，但不会消失，不会像报纸一样消亡，它们将长期存在。</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
       <br>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >16，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >有句古老的德国谚语，我一直非常喜欢，是这么说的：“<strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >人最大的遗憾是，活明白的时候已经老了。</strong
            >”</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
     

      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            text-indent: 0;
    display: inline-block;
    margin-left: 30px;
          "
          >这个遗憾，人人心中都有。最后也就都想开了，<strong
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >不和自己纠结了，也挺好</strong
          >。我活这一生，没什么想改变的。我觉得，大多数人一生下来就有个幸福指数。人们一生中的幸福程度主要取决于这个幸福指数，而不是一生中的贫富。</span
        >
      </section>
      
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <br>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >17，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >想过得幸福很简单。要想幸福，第一条，</span
          ><strong
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><span
              style="
                max-width: 100%;
                color: rgb(215, 92, 43);
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >降低自己的预期</span
            ></strong
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >。</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
              text-indent: 0;
    display: inline-block;
    margin-left: 30px;
            "
            >另外，身处逆境的时候，要</span
          ><strong
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><span
              style="
                max-width: 100%;
                color: rgb(215, 92, 43);
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >敢于迎难而上、埋头苦干</span
            ></strong
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >。怨天尤人、牢骚不断，只能越来越苦、越来越难。</span
          ></span
        >
      </section>
       <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
              text-indent: 0;
    display: inline-block;
    margin-left: 30px;
            ">还有一些做人做事的准则。罗丝·布朗金有一句座右铭：“始终讲真话，不骗任何人。”</span
        >
        </span>
      </section>
        
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
              text-indent: 0;
    display: inline-block;
    margin-left: 30px;
            "
            >还有李光耀说的，“</span
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >第一次就做对</strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >。”</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            text-indent: 0;
    display: inline-block;
    margin-left: 30px;
          "
          >这些原则都是金玉良言，也都是很朴素的道理。生活中的很多金科玉律都是最简单的道理。</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >&nbsp;</span
        >
      </section>
      <br>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              color: rgb(215, 92, 43);
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >18，</span
              ></strong
            ></span
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >别人信任你，你一定要对得起这份信任。再苦再累，我们都要把活干好。</span
          ></span
        >
      </section>
      <p><br /></p>

      <section
        style="
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          text-align: center;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          max-width: 100%;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              color: rgb(255, 0, 0);
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >价值投资永远不会过时</strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          text-align: center;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          max-width: 100%;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              color: rgb(255, 0, 0);
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >因为我对价投的定义就是创造价值的投资</strong
            ></span
          >
        </p>
      </section>
      <p><br /></p>
      <section
        style="
          margin-right: 10px;
          margin-left: 10px;
          max-width: 100%;
          min-height: 1em;
          letter-spacing: 1.5px;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <strong
          style="
            font-size: 18px;
            letter-spacing: 1.5px;
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          ><span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >问：</span
          ></strong
        ><span
          style="
            font-size: 18px;
            letter-spacing: 1.5px;
            max-width: 100%;
            font-family: 微软雅黑;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >你认为在GDP下行时期，价值投资仍然奏效？</span
        ><span
          style="
            font-size: 18px;
            letter-spacing: 1.5px;
            max-width: 100%;
            font-family: 微软雅黑;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >还是被动投资更好一些？</span
        >
      </section>
      <section
        style="
          margin-right: 10px;
          margin-left: 10px;
          max-width: 100%;
          min-height: 1em;
          letter-spacing: 1.5px;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            font-size: 18px;
            letter-spacing: 1.5px;
            max-width: 100%;
            font-family: 微软雅黑;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        ></span
        ><br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span style="font-size: 18px"
          ><span
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            ></strong
            ><span
              style="
                font-size: 18px;
                letter-spacing: 1.5px;
                background-color: rgb(255, 255, 255);
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >很简单，在我看来，</span
            ><strong
              style="
                font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
                  'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
                  'Microsoft YaHei', Arial, sans-serif;
                font-size: 18px;
                letter-spacing: 1.5px;
                white-space: normal;
                background-color: rgb(255, 255, 255);
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >价值投资永远不会过时。因为在我看来，价值投资就是在你买入股票时永远关注它是否能带来更多价值</span
              ></strong
            ><span
              style="
                font-size: 18px;
                letter-spacing: 1.5px;
                background-color: rgb(255, 255, 255);
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >，</span
            ></span
          ><span style="letter-spacing: 0.544px"
            >按照我的理解，无论买什么股票，价值投资都是付出较低的价格、买入较高的价值。这种投资方式永远不会过时。</span
          ></span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >有的人觉得，价值投资就是挖掘那些账上现金很多，但生意很差的破烂公司。我觉得，这不是价值投资的全部。</span
        >
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br />
      </section>
      <section
        style="
          margin-right: 8px;
          margin-left: 8px;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <span
          style="
            max-width: 100%;
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >依我之见，<strong
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >所有做得正确的投资都是价值投资</strong
          >。区别在于，有的人在好公司中寻找价值，有的人在烂公司中寻找价值。但是，<strong
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >只要真是做价值投资，就都是以较低的价格买入较高的价值</strong
          ></span
        >
      </section>
      <p
        style="
          margin-top: 20px;
          margin-bottom: 20px;
          max-width: 100%;
          box-sizing: border-box;
          overflow-wrap: break-word;
          min-height: 1em;
          letter-spacing: 0.544px;
          white-space: normal;
          font-size: 18px;
          background-color: rgb(255, 255, 255);
          line-height: 1.75em;
          font-family: PingFangSC-Regular, 'PingFang SC', -apple-system,
            BlinkMacSystemFont, 'Open Sans', Arial, 'Hiragino Sans GB',
            'Microsoft YaHei', STHeiti, 'WenQuanYi Micro Hei', SimSun,
            sans-serif;
        "
      >
        <span
          style="
            font-family: 微软雅黑, 'Microsoft YaHei';
            letter-spacing: 0.544px;
          "
          >芒格针对这一现象指出：“当利率像现在这么低的时候，每个人都愿意以更高的市盈率持有股票。我认为，</span
        ><span
          style="
            font-family: 微软雅黑, 'Microsoft YaHei';
            letter-spacing: 0.544px;
            max-width: 100%;
            color: rgb(0, 0, 0);
            font-weight: 700;
          "
          >优秀的公司以比过去高得多的倍数出售股票，并不一定是疯狂的</span
        ><span
          style="
            font-family: 微软雅黑, 'Microsoft YaHei';
            letter-spacing: 0.544px;
          "
          >。”</span
        ><br />
      </p>
      <p
        style="
          margin-top: 20px;
          margin-bottom: 20px;
          max-width: 100%;
          box-sizing: border-box;
          overflow-wrap: break-word;
          min-height: 1em;
          letter-spacing: 0.544px;
          white-space: normal;
          font-size: 18px;
          background-color: rgb(255, 255, 255);
          line-height: 1.75em;
          font-family: PingFangSC-Regular, 'PingFang SC', -apple-system,
            BlinkMacSystemFont, 'Open Sans', Arial, 'Hiragino Sans GB',
            'Microsoft YaHei', STHeiti, 'WenQuanYi Micro Hei', SimSun,
            sans-serif;
        "
      >
        <span
          style="
            font-family: 微软雅黑, 'Microsoft YaHei';
            letter-spacing: 0.544px;
          "
          >芒格补充道：</span
        ><span
          style="
            font-family: 微软雅黑, 'Microsoft YaHei';
            letter-spacing: 0.544px;
          "
          >“好的投资都是价值投资。</span
        ><span
          style="
            font-family: 微软雅黑, 'Microsoft YaHei';
            letter-spacing: 0.544px;
          "
          >只是有些人在强公司中寻找价值，有些人在弱公司中寻找价值。</span
        ><span
          style="
            font-family: 微软雅黑, 'Microsoft YaHei';
            letter-spacing: 0.544px;
          "
          >”</span
        ><br />
      </p>
      <p
        style="
          margin-top: 20px;
          margin-bottom: 20px;
          max-width: 100%;
          box-sizing: border-box;
          overflow-wrap: break-word;
          min-height: 1em;
          letter-spacing: 0.544px;
          white-space: normal;
          font-size: 18px;
          background-color: rgb(255, 255, 255);
          line-height: 1.75em;
          font-family: PingFangSC-Regular, 'PingFang SC', -apple-system,
            BlinkMacSystemFont, 'Open Sans', Arial, 'Hiragino Sans GB',
            'Microsoft YaHei', STHeiti, 'WenQuanYi Micro Hei', SimSun,
            sans-serif;
        "
      >
        <span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >作为全球顶级价值投资者，芒格一直在以低于其内在价值估值的折扣价购买优秀企业的股票，并长期持有这些股票。他在塑造沃伦•</span
        ><ai
          type="15"
          parm="{}"
          style="
            max-width: 100%;
            cursor: pointer;
            display: inline;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            color: inherit !important;
          "
          ><span
            style="
              max-width: 100%;
              font-family: 微软雅黑, 'Microsoft YaHei';
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >巴菲特</span
          ></ai
        ><span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >的投资风格方面发挥了重要作用，推动他从“雪茄烟蒂投资”变成只持有“美妙”企业的股票。</span
        >
      </p>
      <p
        style="
          margin-top: 20px;
          margin-bottom: 20px;
          max-width: 100%;
          box-sizing: border-box;
          overflow-wrap: break-word;
          min-height: 1em;
          letter-spacing: 0.544px;
          white-space: normal;
          font-size: 18px;
          background-color: rgb(255, 255, 255);
          line-height: 1.75em;
          font-family: PingFangSC-Regular, 'PingFang SC', -apple-system,
            BlinkMacSystemFont, 'Open Sans', Arial, 'Hiragino Sans GB',
            'Microsoft YaHei', STHeiti, 'WenQuanYi Micro Hei', SimSun,
            sans-serif;
        "
      >
        <span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >如今，要找到与内在价值相当大折扣的“出色企业”，难度要大得多。市盈率处于较高水平，甚至连查理•芒格(Charlie
          Munger)本人也暗示，在如今的泡沫市场中，没有什么便宜的东西可买。不管喜欢与否，芒格和</span
        ><ai
          type="15"
          parm="{}"
          style="
            max-width: 100%;
            cursor: pointer;
            display: inline;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
            color: inherit !important;
          "
          ><span
            style="
              max-width: 100%;
              font-family: 微软雅黑, 'Microsoft YaHei';
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >巴菲特</span
          ></ai
        ><span
          style="
            max-width: 100%;
            font-family: 微软雅黑, 'Microsoft YaHei';
            font-size: 18px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
          >都将继续投资，尽管他们认为未来10年的市场回报率将低于过去10年。</span
        >
      </p>
      <section
        style="
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          text-align: center;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          font-size: 16px;
          max-width: 100%;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              color: rgb(255, 0, 0);
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >有时分散投资反而会恶化投资</strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          text-align: center;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          font-size: 16px;
          max-width: 100%;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              color: rgb(255, 0, 0);
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >拿稳几只你深度了解的股票比买100只股票更好</strong
            ></span
          >
        </p>
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              color: rgb(255, 0, 0);
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><br /></strong
          ></span>
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="letter-spacing: 1.5px; font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ></span
          ><span
            style="
              letter-spacing: 1.5px;
              font-size: 18px;
              max-width: 100%;
              font-family: 微软雅黑;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >有趣的是，</span
          ><strong
            style="
              letter-spacing: 1.5px;
              font-size: 18px;
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >很多人认为持有100多只股票比只买了4、5只股票显得更专业，我觉得这种观点有问题。我认为找到4、5只稳定赚钱的股票比起找到100只赚钱的股票要简单的多。</span
            ></strong
          >
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              font-family: 微软雅黑;
              font-size: 18px;
              letter-spacing: 1.5px;
            "
          ></span>
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >我知道很多人说持股多体现了分散投资的理念，但有时我不认为这是分散投资，我称之为“恶化投资”。对我来说，持有2、3只更加熟悉的股票让我感到更加舒适。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >伯克希尔最近卖出了大量富国银行的股票，但是Daily
              Journal只卖了一点点？如果对于伯克希尔来说，富国银行不值得持有，那对于Daily
              Journal来说是否应该采取一致标准？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我不认为两家公司在所有事情上都要保持一致，两家公司在税收上的考虑就不一样。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >毋庸置疑的是，富国银行在长期投资价值上来看是令人失望的，因为它老旧的管理模式、糟糕的企业文化以及较低的员工激励。我们并不是恶意卖出，而是看到富国银行的一些员工已经出现了欺骗客户的行为，令人遗憾。</span
          >
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          white-space: normal;
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >因此巴菲特对富国银行不再抱有任何幻想，选择了卖出，相比之下，我对银行家们更加宽容，不像巴菲特那么高标准、严要求。</span
          >
        </p>
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><br
          /></span>
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >华尔街散户的投机行为和无良券商的推波助澜让美股弥漫着赌场的危险气息</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >面对市场疯狂应该静观其变而不是加入赌局</strong
                        ></span
                      >
                    </p>
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          ><br /></strong
                      ></span>
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >谢谢芒格，第一个问题来自麦克·王（Michael
              Wang），他的问题是，你在今年的股东信中提到今年的股价上涨主要是由于市场投机热潮，那是不是可以认为目前全市场也处于这种投机狂热之中？这种市场行为意味着什么？投资者该如何应对这种阶段性的市场狂热？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >这种疯狂的繁荣景象在市场经济下时有发生，在互联网泡沫时期，硅谷的房租也随之暴涨，但是短短几个月之后，三分之一的办公室人去楼空。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >在我数十年的投资生涯中见证了太多这样的情况，我的应对方式就是静观其变——这也正是股东应该采取的方式，但是很多股东会拥向人群，购买股票，加入狂欢，甚至不惜加杠杆，因为他们不想错过上涨。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >——这种投资方式自然是十分危险的，我认为股东们应该更加理性，而不是想要追涨而去买入——这和赌博没什么两样。</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >对于赌博，就像一首诗的结尾所说的：“你应该学会克制，但我知道你不会听从我的建议。”</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >好了，下一个问题。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >有不少股东对最近散户的狂热行为很好奇，比如嘉文·史密斯 （Gavin
              Smith）
              的问题是，你对最近游戏驿站的散户逼空行为怎么看？这件事对未来的卖空行为有什么影响？另一位股东李（Lee）也希望你讲讲对最近WSB散户行为的看法。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >当一大群人把股市当成是赌场的时候，这种事情就会发生，而这就是当前股市上正在发生的事。那些从这群赌徒身上抽取佣金收入的人会火上浇油，助长这种疯狂。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >当情况变得极端，就会出现逼空，一般会关注逼空行为的是清算机构，而不是普罗大众，但就像这次一样，整个事件完全出圈了，大家甚至开始关心清算所是否会崩溃，这就相当危险了。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >任由这种赌徒文化充斥在资本市场是非常愚蠢的，这会导致麻烦——事实上已经产生了不少麻烦。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >对于这种散户狂热行为，我有一个简单的建议，</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >就是经纪商要向客户推荐对他们有利的股票，而不是为了赚取更多的佣金收入而向他们提供赌博服务。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >现在有些新的股票经理人，纯靠兜售带有投机性质的股票来为自己牟利，我认为这种赚钱手段是非常龌龊的</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >，允许这种情况发生的市场本身也是疯狂的。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      text-align: center;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >云化和软件服务是未来</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      text-align: center;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >Daily Journal是跟微软不同类的软件服务公司</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      text-align: center;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >我们把自己看成是公共服务</strong
                        ></span
                      >
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >下一个问题是安德鲁·威尔金森（Andrew
              Wilkinson）问的，他想知道你对Daily
              Journal未来十年的发展有什么期望？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我当然希望他们的软件服务取得成功，尤其是在软件服务日益重要的现代社会，这可能实现，但也说不好；我还希望它的传媒业务能继续存活下去，当然这一点也不一定。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >接下来是马修·彼得森（Matthew
              Peterson）提出的问题，JTI公司（Journal Technologies, Inc.，Daily
              Journal的子公司）通过线上技术让大家开始习惯在线提交法律文书等事项，现在大部分软件公司的合同收入都是来自订阅和许可费用，你认为这些产品上线后主要的辅助收入来源是什么？这些产品的意义与电子文档、电子支付或云服务相比怎么样？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >谁也不知道软件服务最后会发展成什么样，但我们知道在法院边上开停车场不再是什么好生意了，因为未来很多案子会直接在线审理。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >云端化、在线化是一个很美好的事情，现在有些小国家，像爱沙尼亚，几乎整个国家都在互联网上。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >所以云化是一个高速增长的领域，这对我们来说是一个好消息，但是坏消息是谁也不知道最后谁会胜出。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >一般大家会认为Daily
              Journal是一个像微软那样的软件公司，但是实际上</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >我们不同于微软，针对提案请求流程（RFP
                Process）的在线软件服务挺难做的，无论是确定性和还是盈利都与微软无法相提并论，但是我们喜欢这份事业，并把它看成一个重要的公共服务。</span
              ></strong
            ></span
          >
        </p>
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                ><br /></span></strong
          ></span>
        </p>
      </section>
      
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >李克、巴菲特和我曾是铁三角组合</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >他非常幽默，绝顶聪明</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >到我这个岁数</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >朋友走一个就少一个</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >没人可以替代了</strong
                        ></span
                      >
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >有不少投资者想听你谈谈李克·古瑞恩（Rick
              Guerin，巴菲特、芒格的早期合伙人，2020年10月以90岁高龄过世）以及你们最珍贵的回忆。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >几十年来，他是我最亲密的朋友，他是一位优雅的绅士、一个贴心的伙伴。当然我们曾经也一起完成了不少壮举，李克和巴菲特还有我曾经是铁三角，我们在一起工作过很长一段时间。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >李克从来都是那么幽默、那么富有智慧，他当时参加了美国海军的智商测试，取得了最高的记录之一，这也是为什么他的人生上升得如此之快——他实在是太tm聪明了。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >和他在一起你永远不会无聊，他喜欢跳伞、跑马拉松，如果不是和他在一起，我绝不会尝试包括这些在内的事情。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >李克充满勇气，乐善好施，他活到90岁，走完了精彩纷呈的人生岁月。在我这个年纪，朋友走一个就少一个了，没人可以替代他们。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >不少股东关心接班人相关的情况，伯克希尔·哈撒韦的接班人已经在平稳过度中，Daily
              Journal的有关情况进行得如何？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >杰瑞的团队做的非常好，在软件行业，和一些主要的竞争者相比，我们只是一家小公司，但是团队会继续努力，我认为未来会持续向好发展。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >当前美股的泡沫会以惨烈的方式结束</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >但我不知道何时会崩盘</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >不会有人因为在市场狂热时买了高估值的股票而致富</strong
                        ></span
                      >
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >很多人认为现在的情况和互联网泡沫时期相似，市场行为像极了90年代末期，最终这波行情回以惨烈的方式结束。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >是的，我同意，会以惨烈的方式结束，但我不知道什么时候会崩盘。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >问：现在似乎所有名人，包括歌手、演员、运动员、政客，都在宣传自己的SPAC（Special
            Purpose Acquisition
            Company，一种迅速借壳上市的融资模式）上市，你怎么看？</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >对此类行为我从不参与，但是</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >我觉得没有SPAC这个世界会变得更好，因为这是一种疯狂的投机行为，借壳上市的公司甚至都不存在，所以它只是泡沫的一种表现，对于承销这些东西的投行来说，它们正在做的就是尽可能把狗屎卖出去。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >去年2月，你提到金融体系存在过剩问题，现在一年过去，你能不能分享一下你最近的观察，最糟糕的过剩出现在哪些领域？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >最夸张的过剩行为散户受到Robinhood这种在线券商的怂恿进行的动量投资行为。我认为这种市场行为是令人惋惜的。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >1700年代，历史上第一次泡沫发生，就是英国的南海泡沫，在泡沫破灭后引发了巨大灾难，导致了英国关闭了很长一段时间的公开证券交易。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >此后，市场上每过一段时间就会出现新的泡沫，我认为明智的人应该远离它们。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你在之前的演讲中提到，当交易参与双方都认为一类资产比它的实际价值更值钱的时候，泡沫就产生了，美国国库券目前符合你说的这种情况吗？因为美债价值决定了其他资产类别的价格，如果它确实泡沫化了，那将意味着什么？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >不，我不认为美国国库券有泡沫存在，在低利率下，我不认为它是一项好的投资品种，但我不认为美国国债有什么大问题。我不知道的是目前人为调控的低利率以及政府如此大量超印货币会对未来产生怎样的影响。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我不认为有人确定未来的情况会如何演变，有人抱怨说现在经济刺激方案太多了，我不知道他们说的是否有道理。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你曾经说过，现在持有现金，按兵不动需要很强的定力，但是你也说如果只有平庸的机会，你宁愿保持不动。如今权益资产大涨，而现行的货币政策下，现金越来越被认为是有风险的，你的想法是否有所改变，或者对投资标的的标准有所降低？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我认为在总体市盈率这么高的情况下，持有股票的人都希望利率保持低水平。现在市场对于好公司给出比平时更高的估值并不算匪夷所思，但是最终</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >人们不会因为在市场狂热时期买了高市盈率的股票而致富。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >所以，我不会改变我之前的观点，但是我可能会比以前更能够容忍较高的估值，而且希望保持低利率，就像大多数人一样。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              color: rgb(255, 0, 0);
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >&nbsp;&nbsp;</strong
            ></span
          ><strong
            style="
              font-size: 18px;
              color: rgb(255, 0, 0);
              letter-spacing: 1.5px;
            "
          ></strong>
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      font-size: 16px;
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <br />
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
     
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >银行业最大的问题是银行太多</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >合格的银行家太少</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >比特币不可能成为国际同行的交易媒介</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >它不过是人造的黄金替代品</strong
                        ></span
                      >
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >现在适合投资银行股吗？它们的股价是否更加稳定？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >所有的股票都会有波动，我的确认为经营优秀的银行是很好的投资标的。有人曾说，</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >银行业最大的问题是银行太多，而合格的银行家太少。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >有着巴菲特那样思维模式的执行官很少会遇到麻烦，但这样的人毕竟是少数，把银行经营好是一件很难的事，有太多的诱惑使人犯傻，比如以长期业绩为代价追求短期的好业绩。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >很多银行家会屈服于这种诱惑，所以尽管并非不可能，但投资银行股的确较难获利。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >对银行来说最大的威胁来自哪里？苹果支付或PayPal等公司，会对它们形成颠覆吗？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我不知道未来的银行业具体会是什么样子，也不知道未来的支付系统会如何演变，但我认为经营优秀的银行会对整个人类文明产生贡献，而且各国的央行也会继续控制银行系统和货币供应。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >所以</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >我不认为比特币会成为世界通行的交易媒介，它只不过是一种人造的黄金替代品，而我从未购买过黄金，因此我也不会去买比特币，我希望大家都像我一样别碰比特币，它让我想到奥斯卡·王尔德对当时风靡一时的猎狐行为的评价：一群疯子在追逐一件毫无价值的东西</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >（the pursuit of the uneatable by the unspeakable）。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >的确有不少股东问及比特币的问题，特斯拉最近买入了不少比特币，并把它们纳入到资产负债表中，Daily
              Journal会进行相似的操作吗？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >不，我们不会。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >比亚迪在转型中的中国汽车产业链处于有利位置，我们会继续持有</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >我说不清是50000美元的比特币更离谱，还是特斯拉的市值更离谱</strong
                        ></span
                      >
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >Daily
              Journal的投资组合中持有不少比亚迪的股票，而且这两年来取得了巨大的浮盈，也许比公司内在价值的增长要高得多，你如何决定持有还是卖出一只个股？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >好问题，我们持有比亚迪的前五年，股价基本没什么涨幅，但前两年涨幅很大，原因是</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >比亚迪在中国的汽车产业链从燃油到新能源转型过程中处在有利地位，</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >这让中国的股票投资者推高了它的股价。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我们倾向于继续持有比亚迪，因为我们继续看好它，而且卖出股票需要给加州和联邦政府交很多税。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我一个做风投的聪明朋友，他们持有大量股票，但常常会择机卖出一半仓位，这样之后无论行情如何波动，他都觉得能接受，我们不会这样做，但我也不批评他的做法。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >有个类似的问题，你认为电动车企业的估值是否有泡沫？比亚迪200多倍市盈率——当然这个估值水平相比特斯拉的1100倍PE还比较正常。我知道伯克希尔以长期持有优质公司的股票著称，但是否会存在股价过高以至于公司业绩无法支撑的情况呢？你选择持有而非卖出的原因是什么？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >其实我也很少持有像比亚迪这样估值高到让人血脉贲张的公司，对于选择持有比亚迪，我也还没有形成体系，也还在不断学习。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >我们非常喜欢这家公司，也很欣赏它的管理层，所以我们会遵从内心的真实想法，继续持有。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >两年前，你认为当时美国惟一值得买的股票就是Costco，你为什么认为亚马逊未来需要担心Costco，而Costco不用太担心亚马逊呢？杰夫·贝佐斯是你见过最成功的企业家之一吗？对于他辞去亚马逊CEO之后来要投身的新项目，你感兴趣吗？会选择投资吗？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我非常欣赏杰夫·贝佐斯，我认为他是我见过的最聪明的生意人之一。我们对他的新项目还没有足够了解，所以暂时不会跟注。每个投资人都会遇到艰难的抉择，因为总有很多聪明、值得尊敬的人得出相反的结论。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我之所以认为Costco对亚马逊来说是一个值得关注的威胁，是因为大家都相信Costco能为他们带来巨大的价值，这这个方面，Costco有着比亚马逊更好的口碑。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >像通用电气（GE）这样的公司，有着很好的企业形象，但在股市中迅速沉底。该如何识别哪些公司可能会衰落？对于投资者来说是否可能从这些公司全身而退？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我没有买过GE的股票，我不喜欢它的企业文化，这个公司股价大跌我也不感到惊讶。但我确实认为它目前的CEO非常能干，GE找到了非常合适的领导人，如果有人能够拯救GE，那这个人非他莫属。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你有一套checklist，经常用它复盘自己买过的股票，有哪些指标是你希望更早加入你的checklist的？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >你很善于去评估一个人，尤其是企业家或者是潜在的合作伙伴。有没有一些捷径能够很快的判断一个人是否是一个好的企业家？其实我常常会犯错，回顾这些错我我也常常想如果当时做了相反的决定就好了，但是犯错是无法避免的，成为一个好的投资者也是很难的，现在我对自己宽容多了，&nbsp;我对我的事业还是挺满意的，也不再去向其他人是不是比我做得更好。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我觉得我很幸运，在投资生涯的前期就找到了包括checklist复盘在内的很多投资方法，我建议其他人也遵循我的一些方法。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你和巴菲特很善于去评估一个人，尤其是企业家或者是潜在的合作伙伴。对此你们有什么诀窍？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >如果一个人酗酒，我们不会选他，所有人都有快速发现一些危险的能力，我们只是比其他人更擅长评估危险，这对我们帮助很大，伯克希尔有一个非常重要的优势，我们会与很多优秀的人共事。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >对Daily
            Journal来说也一样，作为一家小型纸媒，在大型纸媒纷纷倒下的时代，Daily
            Journal能够成功转型，离不开优秀的伙伴，当然，萨尔兹曼就是其中之一
            ，我和他从1970年代初就开始一起共事了。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我很早就发现萨尔兹曼可以做到他想做的一切事情，当Daily
            Journal的前任CEO去世时，萨尔兹曼还在律师事务所工作，我们当时想让他来掌管
            Daily
            Journal，他说他对纸媒业务一无所知，但我们看重的是他的能力，认为他一定能够胜任。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >萨尔兹曼果然没有辜负我们的期望，上任后的每一个决策都非常出色，这就是我们对待人才的方式。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你认为是50000美元的比特币更疯狂还是特斯拉的市值更疯狂？你对市场对它们的定价作何评价？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：巨石强森曾说他不知道虱子和跳蚤哪个更糟，我也不知道特斯拉和比特币的市值哪个更糟。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >中国调控经济的手法比我们高明</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >历史上从未有一个大国像中国发展得这么快</strong
                        ></span
                      >
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >下面的提问来自一个学习中国历史的学生，他问，1860年的中国人均GDP是600美元，而在1978年，邓掌权后只有300美元，现在这一数字已经攀升到近万美元，人类历史上从未有过如此快速消除贫困的先例，几十年间让8亿人口摆脱了贫困。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >你非常欣赏中国人的工作态度和儒家价值观，现在中美交恶，西方世界对中国的了解严重不足，我们该如何提升自己的知识水平和对中国文明的了解？</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >对自己的文明有优越感&nbsp;，认为比所有其他文明都好，这很正常，但不可能所有文明都比其他文明更优越。不错，作为一个大国，中国的经济增长在历史上前所未有，这点非常值得关注。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >实事求是地说，</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >我不知道如果中国完全借鉴英国文明化过程中的方方面面，是否会做的比现在更好</span
              ></strong
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >‘</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >但我猜如果真的全部照搬，中国不可能取得今天的成就，因为他们当时处境是那么严峻，中国的贫困人口也非常巨大，因此他们需要采取极端措施来改善他们所处的情况。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >所以我认为中国这些年的路线对他们来说大概率是正确的，我们也不应该自大地对中国横加指责，教他们像我们一样做。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >因为最可能的情况是，我们的模式适合我们，而中国模式更适合中国。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你投资中国股票非常成功，你对中国政府的调控政策怎么看，比如蚂蚁IPO被暂停一事？另外你认为比亚迪是否有一天会被国有化？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我认为比亚迪不太可能被国有化。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >至于马云，</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >考虑到中国的情况，这样的话轮不到他来讲。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >我觉得中国调控经济的方法非常精明，比我们做的好多了，他们也取得了不错的成果，我觉得这样的趋势会持续下去。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >当然，我们都更喜欢自己的文化，我虽然这样说，但是我本人也不愿意住在中国，我更喜欢美国，我的确很欣赏中国这些年的成就，我是说，你怎么能不去欣赏中国的成就呢？</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >没有一个国家能像中国一样在如此短的时间内实现脱贫。现在中国的发展是让人炫目的，中国的工厂现在全是自动化的机器人，中国已经买入现代化国家的行业，而且他们非常善于经营。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >美国刺激政策并非刻意加大贫富差距，而是一个副产物</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >有了贫困，才能够摆脱贫困</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >对于贫困的政策权衡是市场经济体制下最难的课题</strong
                        ></span
                      >
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >现在的美联储政策维持低利率，这让持有金融资产的人获利更多。你觉得我们该怎么做，才能够让那些穷人在疫情中获得一些帮助？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >没有人能准确的知道怎样的宏观经济政策是正确的，也没有人能判断何种程度的经济调控是恰当的，我并不擅长宏观经济预测，但我认为大家对疫情下政府刻意加大贫富差距的指责是不恰当的，没有人想让富人更富，穷人更穷。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >在糟糕的外部环境下，我们都想拯救经济，政府也已经采取了几乎所有切实可行的方式，最后被加大的贫富差距是一个刺激政策的副产物，而不是政策制定者的主观意愿。</span
              ></strong
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >在各个历史的发展阶段，不同阶级造富的速度各不相同，也许下一次就是穷人变富，我认为我们无需对此过度担心，事实是，想让一个国家变富有，需要施行市场经济体质，而在市场经济之下，每个人都像亚当·斯密所说的那样去追求财富。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >这有时会造成矛盾的激化，因为穷人会遭受剥削和痛苦，但是这在一定程度上也给了穷人摆脱贫困的动力，换句话说，市场经济体质是一个能够自我纠偏的系统。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >所有的经济学教科书都没有提到贫穷是所有发展中的经济体所需要的，因为人们要摆脱“贫困”，首先必须要现有“贫困”存在。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >如果贫困被彻底消除，也许对于经济发展来说是事与愿违的，所以如何应对贫困是一个非常艰深的课题。大多数人都简单假设如果所有人都变得巨富，比如每秒钟赚10万美元，我们可以这样做（因为印钞并不难），但我们决不能这样做。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你最近发出了一些警告，政府在超印货币，那么你觉得现代货币系统应是怎么样的？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我觉得现代货币体系应该减少人们对过度通胀的恐惧，确保像德国魏玛共和国时期的灾难性通胀不会发生，我认为目前的货币理论是也许正确的，但具体我也很难说。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >美联储现在的政策在支撑了目前的资产价格，你认为这些政策的长期结果会是什么？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我不知道未来经济运行是否会顺利，我也不认为Daily
              Journal有更好的宏观经济洞见，因而能在未来运营得更好。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >但我的确不那么担心不平等的问题了，很多人诟病这一点，诚然，当下的政策必然会造成一定程度的贫富差距加大，但我们也希望穷人能够脱贫。现在的情况下，即便是比较富裕的家庭也可能很快变穷，所以我对这种程度不平等并不担忧，总会有一些人比其他人富得更快。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >我认为中国人在贫富差距的处理上也非常明智，让一部分人先富起来，而且中国的遗产税是0，我认为这也许是对的。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <section
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <section
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          >
            <section
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
            >
              <section
                style="
                  max-width: 100%;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
              >
                <section
                  style="
                    max-width: 100%;
                    box-sizing: border-box !important;
                    overflow-wrap: break-word !important;
                  "
                >
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >开始学习商科之前</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >先要了解资本主义的历史</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >心理学是必须要学的</strong
                        ></span
                      >
                    </p>
                  </section>
                  <section
                    style="
                      max-width: 100%;
                      box-sizing: border-box !important;
                      overflow-wrap: break-word !important;
                    "
                  >
                    <p
                      style="
                        margin-right: 10px;
                        margin-left: 10px;
                        max-width: 100%;
                        min-height: 1em;
                        letter-spacing: 1.5px;
                        box-sizing: border-box !important;
                        overflow-wrap: break-word !important;
                      "
                    >
                      <span
                        style="
                          max-width: 100%;
                          color: rgb(255, 0, 0);
                          font-size: 18px;
                          box-sizing: border-box !important;
                          overflow-wrap: break-word !important;
                        "
                        ><strong
                          style="
                            max-width: 100%;
                            box-sizing: border-box !important;
                            overflow-wrap: break-word !important;
                          "
                          >而且要与其他知识融会贯通</strong
                        ></span
                      >
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          text-align: center;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <br
          style="
            max-width: 100%;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        />
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >现在大家都在家里，通过zoom以及其他科技手段工作。你如何看待商业房地产的未来？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >房地产一直是一个困难的领域。&nbsp;近年来，某些类型的房地产尤其困难。我认为办公写字楼现在遇到了一些麻烦，而那些用于店租的商业房地产一直有麻烦。&nbsp;公寓会好一些。但是我没有过多参与。我拥有一些公寓楼。只要有一个完善的管理机构（但这很难获得），我就会比较喜欢这项投资。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你曾经说过，了解业务的最佳方法是研究大公司数十年的财务业绩。你还说，如果商学院不采用这种方法，学生会少学到很多东西。&nbsp;你能否详细说明应如何围绕这种方法构建课程？&nbsp;例如，你会推荐什么作为课程材料？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >哈佛商学院以前有商业历史的课程，他们会让学生了解运河的挖掘、铁路的建设，带学生领略工业的起伏、经济的变化等等。这对所有人都有帮助。如果我要教商科，我会采用这个哈佛商学院用了很久的教学方式。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >但现在他们不这么做了，因为教这门课是在从个别教授那里窃取案例，这在学术上对他们来说不方便。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >但是，确实，</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >开始学习商科之前，应该首先研究资本主义的历史，包括它是为什么、怎么运作的。</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >在这方面，很多商学院做得不好。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >长期来看，商业的成功与生物学很像。在生物学中，物竞天择，适者生存。资本主义几乎也是同样残酷的，想一想那些曾经繁荣昌盛的事物，现在已经消亡了。谁曾想到通用汽车和柯达会破产呢？了解这样的历史很有用。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >你说过，人只有在学习了学习方法后才能进步。你有什么学习方法吗？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >我认为我的性格不错。当人们提供给我一个好主意时，我会看到这是一个好主意。&nbsp;然后很快掌握它并开始一直使用它。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >你可能会说每个人都可以做到这一点，但我不认为每个人都可以。没有学习方法，你就像单腿参加比赛，效果不会好。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span
            style="
              max-width: 100%;
              font-family: 微软雅黑;
              font-size: 18px;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
            >顺便说一句，我认为这很难教。你要么拥有，要么没有。</span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >为什么有些人没有学习新的思想和行为的能力？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >这有一部分文化的原因，很多是天生的。有些人会自然而然地做出明智的判断，而另一些人的生活只是一遍又一遍地重复错误。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >问：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >在2005年，你曾讲述了人类误判心理学。现在已经过去了16年。有没有新的观点？</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >芒格：</span
              ></strong
            ><span
              style="
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >的确有一些新想法。但是总得来说，大多数旧知识在很长时间内都管用。</span
            ></span
          >
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <br
            style="
              max-width: 100%;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
            "
          />
        </p>
      </section>
      <section
        style="
          max-width: 100%;
          font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
            'Microsoft YaHei', Arial, sans-serif;
          font-size: 16px;
          letter-spacing: 0.544px;
          white-space: normal;
          background-color: rgb(255, 255, 255);
          line-height: 1.5em;
          box-sizing: border-box !important;
          overflow-wrap: break-word !important;
        "
      >
        <p
          style="
            margin-right: 10px;
            margin-left: 10px;
            max-width: 100%;
            min-height: 1em;
            letter-spacing: 1.5px;
            box-sizing: border-box !important;
            overflow-wrap: break-word !important;
          "
        >
          <span style="font-size: 18px"
            ><span
              style="
                font-size: 18px;
                max-width: 100%;
                font-family: 微软雅黑;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              >运用心理学，你要和其他的知识结合起来。你如果不能掌握其他的知识，你就没有办法把心理学更加综合的运用。但</span
            ><strong
              style="
                max-width: 100%;
                box-sizing: border-box !important;
                overflow-wrap: break-word !important;
              "
              ><span
                style="
                  font-size: 18px;
                  max-width: 100%;
                  font-family: 微软雅黑;
                  box-sizing: border-box !important;
                  overflow-wrap: break-word !important;
                "
                >我认为心理学是必须要学的，并不是只了解一些习惯，而是要把心理学的知识和其他的知识结合起来，这样才能有更深的认知。</span
              ></strong
            ></span
          >
        </p>
        <p class="free">（来源：老罗话指数投资）</p>
      </section>
       
  </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.zhemo{
    text-align: center;
    padding: 40px 0 20px 0;
    font-weight: bold;
     color: #6f6f6f!important;
}
.title2{
    font-weight: bold;
    line-height: 30px;
}
p,span{
    text-indent: 2em;
    font-size: 14px!important;
    color: #6f6f6f!important;
    letter-spacing: 0!important;
}
</style>